const configUrl = require("../../config");
const globalURL = process.env.NODE_ENV === 'development' ? configUrl.baseUrl.devService : configUrl.baseUrl.proService


module.exports = {
  getFriendLinksByModel: {
      url: globalURL + "webApi/friendLinks/getFriendLinksByModel",
      type: "get",
      response: () => {},
  },
  getSystemConfigsByModel: {
      url: globalURL + "webApi/systemConfigs/getSystemConfigsByModel",
      type: "get",
      response: () => {},
  },
  getData: {
      url: " https://webapi.sporttery.cn/gateway/lottery/getWelfareFundV1.qry",
      type: "post",
      response: () => {},
  },
  getData2: {
      url: " https://webapi.sporttery.cn/gateway/lottery/getDigitalDrawInfoV1.qry?isVerify=1&param=85%2C0%3B35%2C0%3B350133%2C0%3B04%2C0%3B20%2C23%3B03%2C32%3B06%2C33%3B19%2C33%3B18%2C35%3B19%2C35%3B190001%2C35%3B72%2C35%3B55%2C46",
      type: "get",
      response: () => {},
  },
  getArticlesByModel: {
      url: globalURL + "webApi/articles/getArticlesByModel",
      type: "get",
      response: () => {},
  },
  getArticlesDetails: {
      url: globalURL + "webApi/articles/getArticlesDetails",
      type: "get",
      response: () => {},
  },
  getCategoriesByModel: {
      url: globalURL + "webApi/categories/getCategoriesByModel",
      type: "get",
      response: () => {},
  },
  getVideosByModel: {
      url: globalURL + "webApi/videos/getVideosByModel",
      type: "get",
      response: () => {},
  },
  getVideosCountByModel: {
      url: globalURL + "webApi/videos/getVideosCountByModel",
      type: "get",
      response: () => {},
  },
  getVideosDetails: {
      url: globalURL + "webApi/videos/getVideosDetails",
      type: "get",
      response: () => {},
  },
  getArticlesCountByModel: {
      url: globalURL + "webApi/articles/getArticlesCountByModel",
      type: "get",
      response: () => {},
  },
  getTicketsByModel: {
      url: globalURL + "webApi/tickets/getTicketsByModel",
      type: "get",
      response: () => {},
  },
  getTicketsCountByModel: {
      url: globalURL + "webApi/tickets/getTicketsCountByModel",
      type: "get",
      response: () => {},
  },
  getTicketsDetails: {
      url: globalURL + "webApi/tickets/getTicketsDetails",
      type: "get",
      response: () => {},
  },
  getTicketImgsByModel: {
      url: globalURL + "webApi/ticketImgs/getTicketImgsByModel",
      type: "get",
      response: () => {},
  },
  getContactUsByModel: {
      url: globalURL + "webApi/contactUs/getContactUsByModel",
      type: "get",
      response: () => {},
  },
  
}